export const NotiStackConstants = {
	NOTISTACK_CREATE: 'NOTISTACK_CREATE',
	NOTISTACK_DELETE: 'NOTISTACK_DELETE',
};
